import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.Devices.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.Devices.form.titleCreate')) + "\n    " + _vm._s(_vm.formItem.id ? ` - ${_vm.formItem.title}` : '') + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.update
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.saveAndCreate')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_vm.formItem ? _c(VForm, {
    ref: "form",
    staticClass: "device-form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.title'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Common.table.eui'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "readonly": "",
      "hide-details": "auto",
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.formItem.eui,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "eui", $$v);
      },
      expression: "formItem.eui"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "filter": _vm.filterItems,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.formItem.deviceTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "deviceTypeId", $$v);
      },
      expression: "formItem.deviceTypeId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.description'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "rows": "4"
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1)], 1), _c('niota-classic-devices-edit-device-form', {
    attrs: {
      "editedItem": _vm.formItem,
      "formSaving": _vm.formSaving,
      "showStatics": true,
      "deviceTypes": _vm.deviceTypes,
      "showDeviceType": false,
      "isIotHubManager": _vm.isIotHubManager,
      "adrLimits": _vm.adrLimits
    },
    on: {
      "updateData": _vm.updateFormData
    }
  }), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-n1-tags', {
    attrs: {
      "tags": _vm.formItem.tags
    },
    on: {
      "process": _vm.tagsChanged
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-1",
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.properties')))])])], 1), _vm._l(_vm.extraFields, function (field, i) {
    return _c(VRow, {
      key: i,
      attrs: {
        "align": "top"
      }
    }, [_c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('core-icons', {
      attrs: {
        "faStyle": "solid",
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "dense": ""
      },
      on: {
        "input": _vm.revalidateForm
      },
      model: {
        value: field.icon,
        callback: function ($$v) {
          _vm.$set(field, "icon", $$v);
        },
        expression: "field.icon"
      }
    })], 1), _c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('NiotaClassic.Devices.form.propertyKey'),
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "rules": [v => _vm.validateDeviceProperties(i, v)],
        "hide-details": "auto"
      },
      on: {
        "input": _vm.revalidateForm
      },
      model: {
        value: field.name,
        callback: function ($$v) {
          _vm.$set(field, "name", $$v);
        },
        expression: "field.name"
      }
    })], 1), _c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('NiotaClassic.Devices.form.propertyValue'),
        "disabled": !_vm.isIotHubManager || _vm.formSaving,
        "rules": [v => _vm.validateDeviceProperties(i, v)],
        "hide-details": "auto"
      },
      on: {
        "input": _vm.revalidateForm
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-plus",
              "title": _vm.$i18n_t('Common.addNew'),
              "disabled": !_vm.isIotHubManager
            },
            on: {
              "click": function ($event) {
                return _vm.addKeyValuePair();
              }
            }
          }), _c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt",
              "title": _vm.$i18n_t('Common.delete'),
              "disabled": !_vm.isIotHubManager
            },
            on: {
              "click": function ($event) {
                return _vm.removeKeyValuePair(i);
              }
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: field.value,
        callback: function ($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    })], 1)], 1);
  }), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.application'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.applications,
      "filter": _vm.filterItems,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "rules": [() => !!_vm.formItem.applicationId || this.$i18n_t('Common.fieldRequired')],
      "auto-select-first": "",
      "clearable": "",
      "required": "",
      "hide-details": "auto",
      "item-text": "title",
      "item-value": "id"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }], null, false, 2098911049),
    model: {
      value: _vm.formItem.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "applicationId", $$v);
      },
      expression: "formItem.applicationId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": "Region",
      "icon": "globe",
      "type": "icon",
      "value": _vm.getRegionText(_vm.formItem)
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-address-picker', {
    attrs: {
      "disabled": !_vm.isIotHubManager,
      "addressObject": _vm.addressObject,
      "coordinateLookup": _vm.coordinateLookup,
      "floatRule": false,
      "callFromN1": true
    },
    on: {
      "address-selected": _vm.addressSelected
    }
  })], 1)], 1)], 2) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };